/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
/*
this page used to grid page size dropdownlist  
 */

// System defined variables
import React, { useState, useEffect } from 'react' // useCallback, useEffect
import { useRecoilValue } from 'recoil'
import gridConstants from '../../../../utils/gridConstants.js'

// Custom defined variables
import Dropdown from '../../base/dropdown/Dropdown'
import utils from '../../../../utils/utils'
import { timezoneAtom } from '../../recoil/atoms/atoms'
import './GridPageSize.css'
import RefreshButton from '../../../../assets/static/Vector.svg'
import ColumnFilterIcon from '../../../../assets/images/columnFilterIcon.svg'
import ButtonComponent from '../../base/button/Button'

const GridPageSize = ({
  onPageSizeHandler,
  isRefreshEnabled,
  onRefreshClickHandler,
  triggerRefresh,
  timezoneType,
  isColumnFilter,
  columnFilterEnable,
  isCustomButton = false,
  customButtonJSX = null,
}) => {
  const timezoneData = useRecoilValue(timezoneAtom)
  const initialState = {
    ddlPerPageValue: String(gridConstants?.defaultPaginationValue),
  }
  const [values, setValues] = useState(initialState)
  const [refreshedDateTime, setRefreshedDateTime] = useState('')

  const onChangeHandler = (event, params) => {
    const ddlValue = params?.value
    setValues({ ...values, [params?.id]: ddlValue })
    onPageSizeHandler(event, params)
  }

  const getIanaTimezone = () => {
    let ianaTimezone = ''
    if (timezoneType?.toString()?.toLowerCase() === 'contract') {
      ianaTimezone = timezoneData?.selectedContract?.timezoneId
    } else if (timezoneType?.toString()?.toLowerCase() === 'case') {
      ianaTimezone = timezoneData?.searchedCase?.timezoneId
    } else {
      ianaTimezone = timezoneData?.default?.timezoneId
    }
    return ianaTimezone
  }

  const handleRefreshClick = () => {
    setRefreshedDateTime(
      utils?.returnCurrentDateTimeBasedOnTimezone(getIanaTimezone())
    )
    onRefreshClickHandler()
  }

  useEffect(() => {
    setRefreshedDateTime(
      utils?.returnCurrentDateTimeBasedOnTimezone(getIanaTimezone())
    )
  }, [])

  useEffect(() => {
    // Added this to trigger auto refresh
    if (triggerRefresh === true) {
      handleRefreshClick()
    }
  }, [triggerRefresh])

  return (
    <div className="gridPageSizeHeader">
      <div className="gridPageSize" data-testid="gridPageSize">
        <span>Show</span>

        <Dropdown
          Field={{
            className: 'colWiseControl',
            fieldLabel: 'Show',
            fieldValue: 'ddlPerPageValue',
            datasource: [
              { id: '10', name: '10', type: 'select' },
              { id: '25', name: '25' },
              { id: '50', name: '50' },
              { id: '100', name: '100' },
              { id: 'all', name: 'All' },
            ],
            valueField: 'name',
            textField: 'name',
          }}
          dataTestId="ddl_gridEntriesPerPage"
          value={values?.ddlPerPageValue}
          onChangeHandler={onChangeHandler}
        />
        <span>entries</span>
      </div>
      {isRefreshEnabled && (
        <div className="gridRefreshDiv">
          <p className="refreshedDateTime">
            Last updated : {refreshedDateTime}
          </p>

          <img
            className="gridPageRefresh"
            src={RefreshButton}
            onClick={handleRefreshClick}
            data-testid="dataUpdateRefresh"
          />
        </div>
      )}

      {isColumnFilter && (
        <div
          className="columnFilterSection"
          onClick={() => columnFilterEnable(true)}
        >
          <img
            className="columnFilterImage"
            src={ColumnFilterIcon}
            data-testid="columnFilterdiv"
          />
          <p className="columnFilterLabel">Column Filter</p>
        </div>
      )}
      {isCustomButton && customButtonJSX && (
        <div className="customButtonSection">{customButtonJSX}</div>
      )}
    </div>
  )
}

export default GridPageSize
